// extracted by mini-css-extract-plugin
export default {"wrapper":"FormError_wrapper__FkG9K"};